import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberAddTravelCoordinator {
	private travelCoordForm:any   = $('#member-add-travel-coordinator');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any   = $.makeArray(_self.travelCoordForm.find('input[type="text"], input[type="email"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr = $('#add-travcord--date-of-birth');
		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getFullYear() - 17).toString());

		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);

		// set default date to 1 Jan 1990
		inputDateArr.datepicker('option', 'defaultDate', new Date('1990-01-01') );
	}

	initTables(): any {
		let _self = this;

		let travelCoordinatorTable = $('#members--add-travel-coordinator table, #members--edit-travel-coordinator table');
		_self.memberBase.initTables(travelCoordinatorTable);
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.travelCoordForm, function(validation: any) {
			// all your custom validation here

			// confirm email validation
			let emailId:string = 'add-travcord--personal-email';
			let confirmEmail:any = _self.travelCoordForm.find('#add-travcord--personal-email-confirm');

			confirmEmail.attr('data-parsley-equalto', '#'+emailId);
		},
		function(validation:any, formData:any) {
			// on success function
		});
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;

		var titleInput = $('#add-travcord--title');
		var getTitleOptions = $.Deferred();

		$.get('/content/dam/mas/json/TitleCode.json')
			.done((data:any) => {
				var listItems = "<option value=''> </option>";
				for (var i = 0; i < data.Titles.length; i++) {
					listItems += "<option value='" + data.Titles[i].Code + "'>" + data.Titles[i].Name + "</option>";
				}
				getTitleOptions.resolve(listItems);
			})
			.fail((error:any) => {
				getTitleOptions.reject(error);
			});

		var countryInput = $('#add-travcord--personal-address-country');
		var getCountryOptions = $.Deferred();
		$.get('/content/dam/mas/json/countrycode.json')
			.done((data:any) => {
				var listItems = "<option value=''> </option>";
				for (var i = 0; i < data.Countries.length; i++) {
					listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
				}
				getCountryOptions.resolve(listItems);
			})
			.fail((error:any) => {
				getCountryOptions.reject(error);
			});

		$.when(getTitleOptions, getCountryOptions).done(function(titleOptions:any, countryOptions:any) {
			titleInput.html(titleOptions);
			countryInput.html(countryOptions);
			let inputSelectArr:any = $.makeArray(_self.travelCoordForm.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
		});
	}


	/**
	 * [initPhoneInput description]
	 * @return {any} [description]
	 */
	initPhoneInput(): any {
		let _self = this;

		let phoneCodeInput:any         = $('#add-travcord--personal-phone--home-country-code');
		let phoneCodeInputMobile:any   = $('#add-travcord--personal-phone--mobile-country-code');
		let phoneCodeInputPersonal:any = $('#add-travcord--personal-phone--office-country-code');
		let phoneCodeInputFax:any      = $('#add-travcord--personal-phone--fax-country-code');
		let getPhoneOptions = $.Deferred();

		$.get('/content/dam/mas/json/PhoneCode.json')
			.done((data:any) => {
				var listItems = "<option value=''> </option>";
				for (var i = 0; i < data.Phonecodes.length; i++) {
					listItems += "<option value='" + data.Phonecodes[i].Code + "'>" + data.Phonecodes[i].Code + "</option>";
				}
				getPhoneOptions.resolve(listItems);
			}).fail((error:any) => {
				getPhoneOptions.reject(error);
			});

		$.when(getPhoneOptions).done(function(titleOptions:any) {
			phoneCodeInput.html(titleOptions);
			phoneCodeInputMobile.html(titleOptions);
			phoneCodeInputPersonal.html(titleOptions);
			phoneCodeInputFax.html(titleOptions);

			let inputElArr:any = $.makeArray(_self.travelCoordForm.find('.phoneinput'));
			_self.memberBase.initPhoneInput(inputElArr);

			// change phone number field validation message
			let phoneNumberFields = _self.travelCoordForm.find('.phoneinput input[type="tel"]');

			phoneNumberFields.each((i:number, el:any) => {
				$(el).attr({
					'data-parsley-type-message': 'This value should be a valid number.'
				});
			});
		});
	}

	fillTheDetails(): void {
		let _self = this;
		let data:any = {
			'id': _self.readParam("id"),
			'action': 'fetch'
		};

		$.ajax({
			type: 'POST',
			url:'/bin/services/new/travelcoordinator',
			data: data,
			success: function(msg:any) {
				_self.redirectUser(msg);
				var json = JSON.parse(msg);

				$("#travelcoordinatorid").val(_self.readParam("id"));
				$(".name").html(json.title+" "+json.name+" "+json.surname);
				$("#add-travcord--title")[0].selectize.setValue(json.title);

				$("#add-travcord--first-name").val(json.name);
				_self.resetTheInputFieldUI($("#add-travcord--first-name"));

				$("#add-travcord--last-name").val(json.surname);
				_self.resetTheInputFieldUI($("#add-travcord--last-name"));

				$("#add-travcord--passport-number").val(json.passport);
				_self.resetTheInputFieldUI($("#add-travcord--passport-number"));

				$("#add-travcord--date-of-birth").val(json.birthDate);
				_self.resetTheInputFieldUI($("#add-travcord--date-of-birth"));

				$("#add-travcord--level-access")[0].selectize.setValue(json.grantLevel);
				$("#add-travcord--relation-to-member")[0].selectize.setValue(json.relation);
				$("#add-travcord--personal-email").val(json.email);
				_self.resetTheInputFieldUI($("#add-travcord--personal-email"));

				$("#add-travcord--personal-phone--home-country-code")[0].selectize.setValue("+"+json.homeTelCountry);
				$("#add-travcord--personal-phone--home").val(json.homeTelNumber);
				_self.resetTheInputFieldUI($("#add-travcord--personal-phone--home"));

				$("#add-travcord--personal-phone--mobile-country-code")[0].selectize.setValue("+"+json.mobileTelCountry);
				$("#add-travcord--personal-phone--mobile").val(json.mobileTelNumber);
				_self.resetTheInputFieldUI($("#add-travcord--personal-phone--mobile"));

				$("#add-travcord--personal-phone--office-country-code")[0].selectize.setValue("+"+json.bussTelCountry);
				$("#add-travcord--personal-phone--office").val(json.bussTelNumber);
				_self.resetTheInputFieldUI($("#add-travcord--personal-phone--office"));

				$("#add-travcord--personal-phone--fax-country-code")[0].selectize.setValue("+"+json.bussFaxCountry);
				$("#add-travcord--personal-phone--fax").val(json.bussFaxNumber);
				_self.resetTheInputFieldUI($("#add-travcord--personal-phone--fax"));

				$("#add-travcord--personal-address-line-1").val(json.addressline1);
				_self.resetTheInputFieldUI($("#add-travcord--personal-address-line-1"));

				$("#add-travcord--personal-address-line-2").val(json.addressline2);
				_self.resetTheInputFieldUI($("#add-travcord--personal-address-line-2"));

				$("#add-travcord--personal-address-line-3").val(json.addressline3);
				_self.resetTheInputFieldUI($("#add-travcord--personal-address-line-3"));

				$("#add-travcord--personal-address-postcode").val(json.homeZipCode);
				_self.resetTheInputFieldUI($("#add-travcord--personal-address-postcode"));

				$("#add-travcord--personal-address-country")[0].selectize.setValue(json.homeCountry);
				$("#add-travcord--personal-address-city").val(json.homeCity);
				_self.resetTheInputFieldUI($("#add-travcord--personal-address-city"));

				$("#add-travcord--personal-address-state").val(json.homeState);
				_self.resetTheInputFieldUI($("#add-travcord--personal-address-state"));

				_self.showSuccessMessage();
			},
			error:function(msg:any){}
		});
    }

    readParam(name:string):any {
    	return (location.search.split(name + '=')[1] || '').split('&')[0];
    }

    resetTheInputFieldUI(fieldElement:any): void {
    	fieldElement.parent().find('label').addClass('input-filled');
    	fieldElement.addClass('input-focused');
    }

    redirectUser(msg:string): void {
    	if(msg.indexOf("timeout") > -1) {
    		msg = msg.replace("timeout-","");
    		window.location.href = msg;
    	}
    }

    showSuccessMessage(): void {
    	let _self = this;

    	if (_self.readParam("result") == "success") {
    		var successMsg = $('#member-add-travel-coordinator-success');
    		$('body').animate({
    			'scrollTop': 0
    		}, 500, function () {
    			successMsg.fadeIn();
    		});
    	}
    }
}

let scope:Element = document.querySelector('#member-add-travel-coordinator');
let editScope:Element = document.querySelector('.member-edit-travel-coordinator');

if (scope){
	try {
	let memberaddtravelcoordinator = new memberAddTravelCoordinator();
	memberaddtravelcoordinator.initTextInputs();
	memberaddtravelcoordinator.initSelectizeInputs();
	memberaddtravelcoordinator.initDatepickerInputs();
	memberaddtravelcoordinator.initPhoneInput();
	memberaddtravelcoordinator.initTables();
	memberaddtravelcoordinator.showSuccessMessage();

	if (editScope) {
		memberaddtravelcoordinator.fillTheDetails();
	}
	} catch(e) {console.error(e);}
}
